<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-12">
        <div class="card my-4">
          <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
            <div class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3">
              <div class="d-flex justify-content-between align-items-center flex-wrap px-3">
                <h6 class="text-white text-capitalize">반/교사 관리</h6>
                <div class="d-flex align-items-center flex-wrap">
                  <select v-model="filters.classid" class="form-select me-2 searchInput" style="width: fit-content; padding-left: 5px; padding-right: 15px;">
                    <option value="">부서 선택</option>
                    <option v-for="department in departments" :key="department.id" :value="department.id">
                      {{ department.name }}
                    </option>
                  </select>
                  <input
                    v-model="filters.keyword"
                    type="text"
                    class="form-control me-2 searchInput"
                    placeholder="반명/교사명 검색"
                  />
                  <select v-model="filters.useyn" class="form-select me-2 searchInput" style="width: fit-content; padding-left: 5px; padding-right: 15px;">
                    <option value="">상태 전체</option>
                    <option value="Y">사용</option>
                    <option value="N">미사용</option>
                  </select>
                  <button class="btn btn-light text-success me-2 mt-2 mt-sm-0" @click="fetchClassInfo(1)">검색</button>
                  <button class="btn btn-light text-success me-2 mt-2 mt-sm-0" @click="triggerExcelUpload">엑셀 업로드</button>
                  <button class="btn btn-light text-success mt-2 mt-sm-0" @click="openCreate">등록</button>
                  <input
                    ref="excelInput"
                    type="file"
                    accept=".xlsx,.xls"
                    style="display: none"
                    @change="handleExcelUpload"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="card-body px-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th>번호</th>
                    <th>부서코드</th>
                    <th>부서명</th>
                    <th>반코드</th>
                    <th>반명</th>
                    <th>반명2</th>
                    <th>교사ID</th>
                    <th>교사명</th>
                    <th>정렬</th>
                    <th>상태</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="rows.length === 0">
                    <td colspan="10" class="text-center">조회된 자료가 없습니다</td>
                  </tr>
                  <tr v-for="(row, index) in rows" :key="row.id">
                    <td class="text-center">{{ (index + 1) + ((currentPage - 1) * pageSize) }}</td>
                    <td class="text-center">{{ row.classid }}</td>
                    <td class="text-center">{{ row.classname }}</td>
                    <td class="text-center">{{ row.grade }}</td>
                    <td class="text-center name" style="font-weight: bold; color: #0b62ff; cursor: pointer" @click="openEdit(row)">
                      {{ row.gradename }}
                    </td>
                    <td class="text-center">{{ row.gradename2 || "-" }}</td>
                    <td class="text-center">{{ row.teacherid || "-" }}</td>
                    <td class="text-center">{{ row.teachername || "-" }}</td>
                    <td class="text-center">{{ row.ord }}</td>
                    <td class="text-center">{{ row.useyn === "Y" ? "사용" : "미사용" }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="d-flex justify-content-center mt-4">
              <div class="text-center mb-2" v-if="totalRows > 0">
                <small class="text-muted">총 {{ totalRows }}개</small>
              </div>
              <nav aria-label="Page navigation" v-if="totalPages > 0">
                <ul class="pagination">
                  <li class="page-item" :class="{ disabled: currentPage === 1 }">
                    <a class="page-link" href="#" @click.prevent="currentPage > 1 && fetchClassInfo(currentPage - 1)">
                      <span aria-hidden="true">&laquo;</span>
                    </a>
                  </li>
                  <li v-for="page in displayedPages" :key="page" class="page-item" :class="{ active: currentPage === page }">
                    <a class="page-link" href="#" @click.prevent="fetchClassInfo(page)">{{ page }}</a>
                  </li>
                  <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                    <a class="page-link" href="#" @click.prevent="currentPage < totalPages && fetchClassInfo(currentPage + 1)">
                      <span aria-hidden="true">&raquo;</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showModal" class="popup-overlay" @click.self="closeModal">
      <div class="popup-content">
        <h6 class="mb-3">{{ isCreate ? "반 등록" : "반 수정" }}</h6>
        <div class="row">
          <div class="col-md-6 mb-2">
            <label class="form-label">부서</label>
            <select class="form-select" v-model="form.classid" :disabled="!isCreate" @change="onModalClassChange">
              <option value="">선택</option>
              <option v-for="department in departments" :key="department.id" :value="department.id">
                {{ department.name }}
              </option>
            </select>
          </div>
          <div class="col-md-6 mb-2">
            <label class="form-label">반코드</label>
            <input class="form-control" v-model="form.grade" type="text" maxlength="50" :readonly="!isCreate" />
          </div>
          <div class="col-md-6 mb-2">
            <label class="form-label">반명</label>
            <input class="form-control" v-model="form.gradename" :readonly="!isCreate" />
          </div>
          <div class="col-md-6 mb-2">
            <label class="form-label">반명2</label>
            <input class="form-control" v-model="form.gradename2" :readonly="!isCreate" />
          </div>
          <div class="col-md-6 mb-2">
            <label class="form-label">정렬</label>
            <input class="form-control" v-model="form.ord" type="number" min="0" />
          </div>
          <div class="col-md-6 mb-2">
            <label class="form-label">교사 선택</label>
            <select class="form-select" v-model="form.teacherid" @change="onTeacherChange">
              <option value="">선택</option>
              <option v-for="teacher in teacherOptions" :key="teacher.teacherid" :value="String(teacher.teacherid)">
                {{ teacher.grade ? `${teacher.grade} ` : "" }}{{ teacher.name }} ({{ teacher.teacherid }})
              </option>
            </select>
          </div>
          <div class="col-md-6 mb-2">
            <label class="form-label">교사명</label>
            <input class="form-control" v-model="form.teachername" maxlength="50" readonly />
          </div>
          <div class="col-md-6 mb-2">
            <label class="form-label">상태</label>
            <select class="form-select" v-model="form.useyn">
              <option value="Y">사용</option>
              <option value="N">미사용</option>
            </select>
          </div>
        </div>
        <div class="text-end">
          <button class="btn btn-secondary me-2" @click="closeModal">취소</button>
          <button class="btn btn-success" @click="save">저장</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiservice from "@/services/apiservice";
import * as XLSX from "xlsx";

export default {
  name: "ClassManage",
  data() {
    return {
      rows: [],
      departments: [],
      filters: {
        classid: "",
        keyword: "",
        useyn: ""
      },
      pageSize: 20,
      currentPage: 1,
      totalPages: 1,
      totalRows: 0,
      showModal: false,
      isCreate: false,
      teacherOptions: [],
      form: {
        id: null,
        classid: "",
        grade: "",
        gradename: "",
        gradename2: "",
        ord: 0,
        teacherid: "",
        teachername: "",
        useyn: "Y"
      }
    };
  },
  computed: {
    displayedPages() {
      const pages = [];
      const maxVisiblePages = 5;

      if (this.totalPages <= maxVisiblePages) {
        for (let i = 1; i <= this.totalPages; i++) pages.push(i);
      } else {
        let startPage = Math.max(1, this.currentPage - Math.floor(maxVisiblePages / 2));
        let endPage = startPage + maxVisiblePages - 1;
        if (endPage > this.totalPages) {
          endPage = this.totalPages;
          startPage = Math.max(1, endPage - maxVisiblePages + 1);
        }
        for (let i = startPage; i <= endPage; i++) pages.push(i);
      }
      return pages;
    }
  },
  methods: {
    triggerExcelUpload() {
      this.$refs.excelInput.value = "";
      this.$refs.excelInput.click();
    },
    normalizeHeader(header) {
      return String(header || "").replace(/`/g, "").trim().toLowerCase();
    },
    toCanonicalKey(header) {
      const normalized = this.normalizeHeader(header).replace(/[\s\-_()/[\]{}]/g, "");
      const aliases = {
        classid: "classid",
        부서코드: "classid",
        부서id: "classid",
        부서번호: "classid",
        grade: "grade",
        반코드: "grade",
        반id: "grade",
        반번호: "grade",
        반: "grade",
        gradename: "gradename",
        반명: "gradename",
        gradename2: "gradename2",
        반명2: "gradename2",
        teacherid: "teacherid",
        교사id: "teacherid",
        교사코드: "teacherid",
        선생님id: "teacherid",
        teachername: "teachername",
        교사명: "teachername",
        선생님명: "teachername",
        선생님이름: "teachername",
        useyn: "useyn",
        상태: "useyn",
        ord: "ord",
        정렬: "ord"
      };
      if (aliases[normalized]) return aliases[normalized];

      // 헤더가 조금 달라도 핵심 키워드가 있으면 매핑
      if (normalized.includes("classid") || normalized.includes("부서코드") || normalized.includes("부서id")) return "classid";
      if (normalized.includes("grade") || normalized.includes("반코드") || normalized.includes("반id")) return "grade";
      if (normalized.includes("gradename2") || normalized.includes("반명2")) return "gradename2";
      if (normalized.includes("gradename") || normalized.includes("반명")) return "gradename";
      if (normalized.includes("teacherid") || normalized.includes("교사id") || normalized.includes("선생님id")) return "teacherid";
      if (normalized.includes("teachername") || normalized.includes("교사명") || normalized.includes("선생님명")) return "teachername";
      if (normalized.includes("useyn") || normalized.includes("상태")) return "useyn";
      if (normalized.includes("ord") || normalized.includes("정렬")) return "ord";

      return normalized;
    },
    toNumberOrEmpty(value) {
      if (value === null || value === undefined || value === "") return "";
      const n = Number(value);
      return Number.isNaN(n) ? "" : n;
    },
    /** DB `grade` varchar(50) — 엑셀/입력 그대로(문자·숫자·한글). 숫자만 toNumberOrEmpty 쓰지 않음. */
    excelAsGrade(v) {
      if (v === null || v === undefined) return "";
      if (typeof v === "number" && !Number.isNaN(v)) return String(v);
      const s = String(v).trim();
      if (s.length > 50) return s.slice(0, 50);
      return s;
    },
    buildRowFromMapped(mapped) {
      const ordValue = this.toNumberOrEmpty(mapped.ord);
      const teacherIdVal = this.toNumberOrEmpty(mapped.teacherid);
      const teacherNameVal = String(mapped.teachername != null ? mapped.teachername : "").trim();
      return {
        classid: this.toNumberOrEmpty(mapped.classid),
        grade: this.excelAsGrade(mapped.grade),
        gradename: String(mapped.gradename != null ? mapped.gradename : "").trim().slice(0, 50),
        gradename2: String(mapped.gradename2 != null ? mapped.gradename2 : "").trim().slice(0, 50),
        teacherid: teacherIdVal === "" ? null : teacherIdVal,
        teachername: teacherNameVal === "" ? null : teacherNameVal,
        useyn: String(mapped.useyn || "Y")
          .trim()
          .toUpperCase(),
        ord: ordValue === "" ? 0 : ordValue
      };
    },
    /**
     * 헤더가 없이 A:부서코드, B:반명(한글), C:반명2… 만 있는 엑셀/순서형 데이터 지원
     */
    tryRowsFromAoa(sheet) {
      const aoa = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: "" });
      const out = [];
      aoa.forEach((cells) => {
        if (!Array.isArray(cells) || !cells.length) return;
        const c0 = this.toNumberOrEmpty(cells[0]);
        if (c0 === "") return;
        const h0 = String(cells[0] != null ? cells[0] : "")
          .trim()
          .toLowerCase();
        if (h0 === "classid" || h0 === "부서코드" || h0 === "grade" || h0 === "반코드") {
          return;
        }
        // 4열 이상: 부서 / 반코드 / 반명 / 반명2 …
        if (cells.length >= 4) {
          out.push(
            this.buildRowFromMapped({
              classid: c0,
              grade: this.excelAsGrade(cells[1]),
              gradename: String(cells[2] != null ? cells[2] : "").trim(),
              gradename2: String(cells[3] != null ? cells[3] : "").trim(),
              ord: 0
            })
          );
          return;
        }
        // 3열이고 2번 칸이 숫자·숫자문자면: 부서 / 반코드 / 반명
        if (cells.length >= 3) {
          const g1 = this.excelAsGrade(cells[1]);
          const n1 = this.toNumberOrEmpty(cells[1]);
          const isNumericLike = n1 !== "" && (typeof cells[1] === "number" || /^\d+(\.\d+)?$/.test(String(cells[1]).trim()));
          if (g1 !== "" && isNumericLike) {
            out.push(
              this.buildRowFromMapped({
                classid: c0,
                grade: g1,
                gradename: String(cells[2] != null ? cells[2] : "").trim(),
                gradename2: String(cells[3] != null ? cells[3] : "").trim(),
                ord: 0
              })
            );
            return;
          }
        }
        const nums = cells
          .map((c) => (typeof c === "number" && !Number.isNaN(c) ? c : this.toNumberOrEmpty(c)))
          .filter((v) => v !== "" && v !== 0);
        const strs = cells
          .map((c) => String(c != null ? c : "").trim())
          .filter((s) => s !== "" && Number.isNaN(Number(s)));
        if (!nums.length || !strs.length) return;
        out.push(
          this.buildRowFromMapped({
            classid: nums[0],
            grade: "",
            gradename: strs[0] || "",
            gradename2: strs.length > 1 ? strs[1] : "",
            ord: 0
          })
        );
      });
      return out;
    },
    /** 여러 시트가 있을 때 데이터 행이 가장 많은 시트를 사용 (빈 Sheet1 + 데이터 Sheet4 등) */
    getLargestDataSheet(workbook) {
      let bestName = workbook.SheetNames[0];
      let bestCount = -1;
      workbook.SheetNames.forEach((name) => {
        const n = XLSX.utils.sheet_to_json(workbook.Sheets[name], {
          defval: "",
          raw: false,
          blankrows: false
        }).length;
        if (n > bestCount) {
          bestCount = n;
          bestName = name;
        }
      });
      return { sheetName: bestName, dataRowCount: bestCount };
    },
    async handleExcelUpload(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) return;

      try {
        const buffer = await file.arrayBuffer();
        // 한글/국내 엑셀: xlsx는 UTF-8; xls(바이너리)는 codepage 힌트(일부 EUC-KR/CP949 환경)
        const workbook = XLSX.read(buffer, { type: "array", codepage: 65001 });
        const { sheetName, dataRowCount } = this.getLargestDataSheet(workbook);
        const sheet = workbook.Sheets[sheetName];
        const rawRows = XLSX.utils.sheet_to_json(sheet, { defval: "", raw: false, blankrows: false });

        if (!rawRows.length) {
          alert("엑셀 데이터가 비어 있습니다.");
          return;
        }

        let rows = rawRows.map((raw) => {
          const mapped = {};
          Object.keys(raw).forEach((key) => {
            mapped[this.toCanonicalKey(key)] = raw[key];
          });
          return this.buildRowFromMapped(mapped);
        });
        // 헤더 매핑이 안 된 행(반명이 비는데 1열만 있는 경우) → 2차: 순서로 추정
        if (!rows.some((r) => r.classid && r.gradename)) {
          const inferred = this.tryRowsFromAoa(sheet);
          if (inferred.length) {
            rows = inferred;
          }
        }
        // 반코드(grade) varchar — 엑셀 값 그대로, 빈 반코드 행은 제외
        rows = rows.filter(
          (r) => r.classid && r.gradename && String(r.grade != null ? r.grade : "").trim() !== ""
        );

        if (!rows.length) {
          alert(
            "유효한 데이터 행이 없습니다. 부서코드·반코드·반명 열이 모두 있는지 확인하세요."
          );
          return;
        }

        // 대량 행(수백 행) 한 번에 전송 시 타임아웃/서버 제한 방지: 분할 업로드 후 합산
        const CHUNK = 100;
        let created = 0;
        let updated = 0;
        let skipped = 0;
        const allErrors = [];
        for (let i = 0; i < rows.length; i += CHUNK) {
          const chunk = rows.slice(i, i + CHUNK);
          const response = await apiservice.classInfoBulkUpsert({ rows: chunk });
          const data = response.data || {};
          created += data.created || 0;
          updated += data.updated || 0;
          skipped += data.skipped || 0;
          if (data.errors && data.errors.length) {
            allErrors.push(...data.errors);
          }
        }
        const errorPreview = allErrors.slice(0, 8).join("\n");
        alert(
          `시트: ${sheetName} (읽기 ${dataRowCount}행) → 전송 ${rows.length}행\n` +
            `업로드 완료\n등록: ${created}건\n수정: ${updated}건\n건너뜀: ${skipped}건` +
            (errorPreview ? `\n\n오류 일부:\n${errorPreview}` : "") +
            (allErrors.length > 8 ? `\n… 외 ${allErrors.length - 8}건` : "")
        );
        this.fetchClassInfo(1);
      } catch (error) {
        console.error("엑셀 업로드 실패:", error);
        alert("엑셀 업로드 중 오류가 발생했습니다.");
      }
    },
    async fetchDepartments() {
      const response = await apiservice.getdeptlist();
      this.departments = response.data.data.map((department) => ({
        id: department.code,
        name: department.codename
      }));
    },
    async fetchClassInfo(page = 1) {
      try {
        const response = await apiservice.classInfoList({
          params: {
            page,
            limit: this.pageSize,
            ...this.filters
          }
        });
        this.rows = response.data.data || [];
        this.currentPage = parseInt(response.data.currentPage || 1);
        this.totalPages = parseInt(response.data.totalPages || 1);
        this.totalRows = parseInt(response.data.totalRows || 0);
      } catch (error) {
        console.error("Failed to fetch class info:", error);
        this.rows = [];
        this.currentPage = 1;
        this.totalPages = 1;
        this.totalRows = 0;
      }
    },
    async fetchTeacherOptions(classid) {
      if (!classid) {
        this.teacherOptions = [];
        return;
      }
      try {
        const response = await apiservice.getClassManageTeachers({ classid });
        this.teacherOptions = response.data.data || [];
      } catch (error) {
        console.error("Failed to fetch teachers:", error);
        this.teacherOptions = [];
      }
    },
    onTeacherChange() {
      const selected = this.teacherOptions.find(
        (teacher) => String(teacher.teacherid) === String(this.form.teacherid)
      );
      this.form.teachername = selected ? selected.name : "";
    },
    onModalClassChange() {
      this.form.teacherid = "";
      this.form.teachername = "";
      this.fetchTeacherOptions(this.form.classid);
    },
    openCreate() {
      this.isCreate = true;
      this.form = {
        id: null,
        classid: this.filters.classid || "",
        grade: "",
        gradename: "",
        gradename2: "",
        ord: 0,
        teacherid: "",
        teachername: "",
        useyn: "Y"
      };
      this.showModal = true;
      this.fetchTeacherOptions(this.form.classid);
    },
    openEdit(row) {
      this.isCreate = false;
      this.form = {
        id: row.id,
        classid: row.classid,
        grade: row.grade != null && row.grade !== undefined ? String(row.grade) : "",
        gradename: row.gradename,
        gradename2: row.gradename2 || "",
        ord: row.ord,
        teacherid: row.teacherid ? String(row.teacherid) : "",
        teachername: row.teachername || "",
        useyn: row.useyn
      };
      this.showModal = true;
      this.fetchTeacherOptions(this.form.classid).then(() => {
        const exists = this.teacherOptions.find(
          (teacher) => String(teacher.teacherid) === String(this.form.teacherid)
        );
        if (!exists && this.form.teacherid) {
          this.teacherOptions = [
            { teacherid: this.form.teacherid, name: this.form.teachername || "기존 교사", grade: "" },
            ...this.teacherOptions
          ];
        }
      });
    },
    closeModal() {
      this.showModal = false;
    },
    async save() {
      const g = String(this.form.grade != null ? this.form.grade : "").trim();
      if (!this.form.classid || g === "" || !String(this.form.gradename || "").trim()) {
        alert("부서, 반코드, 반명은 필수입니다.");
        return;
      }
      this.form.grade = g.length > 50 ? g.slice(0, 50) : g;
      try {
        if (this.isCreate) {
          await apiservice.classInfoCreate(this.form);
        } else {
          await apiservice.classInfoUpdate(this.form);
        }
        this.showModal = false;
        this.fetchClassInfo(this.currentPage);
      } catch (error) {
        console.error("Failed to save class info:", error);
        alert("저장 중 오류가 발생했습니다.");
      }
    }
  },
  async mounted() {
    await this.fetchDepartments();
    const user = this.$store.state.userData;
    if (user && user.superuser !== "1") {
      this.filters.classid = user.classid;
    }
    await this.fetchClassInfo(1);
  }
};
</script>

<style scoped>
.searchInput {
  text-align: center;
  width: 150px;
  background-color: white !important;
  margin-bottom: 0;
}
.popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.popup-content {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  width: 640px;
  max-width: 95vw;
  border: 1px solid #dee2e6;
}
@media (max-width: 768px) {
  .d-flex {
    flex-direction: column;
    align-items: stretch;
  }
  .form-select,
  .form-control {
    width: 100% !important;
    margin-bottom: 10px;
  }
  .searchInput {
    text-align: left;
  }
}
</style>
